// extracted by mini-css-extract-plugin
export var downArrow = "_9w-0";
export var label = "_9w-1";
export var treatmentCard = "_9w-3";
export var upArrow = "_9w-2";